var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_194_529)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 40.7075C64 35.6641 59.5517 31.5555 54.0644 31.5092C52.8878 27.1601 48.5773 24 43.5914 24C37.6416 24 32.801 28.4397 32.801 33.8968C32.801 33.9438 32.8013 33.9908 32.802 34.0381C32.7518 34.0372 32.7015 34.0369 32.6513 34.0369C27.881 34.0369 24 37.5962 24 41.9715C24 46.3468 27.881 49.9064 32.6513 49.9064H33.6218V53.1263C32.083 53.6152 30.9747 54.957 30.9747 56.5327C30.9747 58.5199 32.7374 60.1368 34.9042 60.1368C37.0713 60.1368 38.834 58.5199 38.834 56.5327C38.834 54.957 37.7254 53.6152 36.1865 53.1263V49.9064H42.7177V56.9895C41.1788 57.4784 40.0702 58.8202 40.0702 60.3958C40.0702 62.3832 41.8329 64 44 64C46.1668 64 47.9295 62.3832 47.9295 60.3958C47.9295 58.8202 46.8212 57.4784 45.2824 56.9895V49.9064H51.8131V53.1263C50.2743 53.6152 49.166 54.957 49.166 56.5327C49.166 58.5199 50.9288 60.1368 53.0955 60.1368C55.2625 60.1368 57.0254 58.5199 57.0254 56.5327C57.0254 54.957 55.9167 53.6152 54.3778 53.1263V49.8981C59.7201 49.7013 64 45.6546 64 40.7075ZM34.9045 57.7848C34.1515 57.7848 33.5393 57.2229 33.5393 56.5327C33.5393 55.842 34.1515 55.2805 34.9045 55.2805C35.6572 55.2805 36.2694 55.842 36.2694 56.5327C36.2694 57.2229 35.6572 57.7848 34.9045 57.7848ZM44 61.6477C43.2474 61.6477 42.6351 61.0862 42.6351 60.3958C42.6351 59.7052 43.2474 59.1437 44 59.1437C44.753 59.1437 45.3652 59.7052 45.3652 60.3958C45.3652 61.0862 44.7527 61.6477 44 61.6477ZM53.0958 57.7848C52.3428 57.7848 51.7306 57.2229 51.7306 56.5327C51.7306 55.842 52.3428 55.2805 53.0958 55.2805C53.8484 55.2805 54.461 55.842 54.461 56.5327C54.461 57.2229 53.8484 57.7848 53.0958 57.7848Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_529",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloudIcon.7d419eb77f31b80f9b291ddff8382955.svg";
export { ForwardRef as ReactComponent };